import React, { useEffect, useState } from 'react';
import { Box, IconButton, TableCell, TableRow, TextField, Tooltip } from '@mui/material';
import { Edit } from '@mui/icons-material';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import { Restore as RestoreIcon } from '@mui/icons-material';
import { PermissionWrapper } from '../../../../wrappers';
import { trackActivity } from '../../../../utils/mixpanel';
import { regexConstants } from '../../../../constants/regEx';

const InvoiceConfigTable = ({ item,onEditSave,viewRevisonHistory }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [userTitle, setUserTitle] = useState(item?.user_defined_title || "");
    const [prevTitle, setPrevTitle] = useState(item?.user_defined_title || "");
    const invoiceType=item?.invoice_type || "";

    useEffect(()=>{
        setUserTitle(item?.user_defined_title || "");
        setPrevTitle(item?.user_defined_title || "");
    },[item])

    const handleEdit = () => {
        setPrevTitle(userTitle);
        setIsEditing(true);
    };

    const handleSave = () => {
        onEditSave(userTitle,invoiceType)
        setIsEditing(false);
    };

    const handleCancel = () => {
        setUserTitle(prevTitle);
        setIsEditing(false);
    };

    const handleItemClicked = (page_type) => {
        trackActivity('Item Clicked', { page_title: `Edit Invoice Title Configuration`, page_type: page_type, })
    }
    return (
        <TableRow hover>
            <TableCell>{item?.invoice_type_label || ""}</TableCell>
            <TableCell>{item?.default_title || ""}</TableCell>
            <TableCell>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <TextField
                        size="small"
                        variant="outlined"
                        value={userTitle}
                        disabled={!isEditing}
                        onChange={(e) => regexConstants.restrictUnicodeCharacters.test(e.target.value) || e.target.value === "" ? setUserTitle(e.target.value.trimStart()) : e.preventDefault()}
                        placeholder="Enter Custom Title"
                        slotProps={{ inputLabel: { shrink: true }, htmlInput: { maxLength: 100 } }}
                        sx={{ width: '400px', flexShrink: 0 }}
                    />
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, width: '64px' }}>
                        {!isEditing && (
                            <>
                                <PermissionWrapper extraProps={{ application: "lease_revamp", feature: "invoices", operationType: ['U'] }}>
                                    <Tooltip title="Edit">
                                        <Edit onClick={() => { handleEdit(); handleItemClicked('EditIcon') }} fontSize="small" color="primary" sx={{ cursor: 'pointer' }} />
                                    </Tooltip>
                                </PermissionWrapper>
                                <Tooltip title="Revision History">
                                    <RestoreIcon className="revision-history" onClick={() => { viewRevisonHistory(); handleItemClicked('RevisionHistoryIcon') }} fontSize="small" color="primary" sx={{ cursor: "pointer" }} />
                                </Tooltip>

                            </>
                        )}
                        {isEditing && (
                            <>
                                <Tooltip title="Save">
                                    <IconButton color="primary" size="small" onClick={()=>{handleSave(); handleItemClicked('Save Button')}} onMouseDown={(e) => e.preventDefault()} sx={{ bgcolor: '#e3f2fd' }}> <CheckIcon fontSize="small" sx={{ fontSize: 16 }} /> </IconButton>
                                </Tooltip>
                                <Tooltip title="Cancel">
                                    <IconButton color="error" size="small" onClick={()=>{handleCancel(); handleItemClicked('Cancel Button')}} onMouseDown={(e) => e.preventDefault()} sx={{ bgcolor: '#ffebee' }}><CloseIcon fontSize="small" sx={{ fontSize: 16 }} /></IconButton>
                                </Tooltip>
                            </>
                        )}
                    </Box>
                </Box>
            </TableCell>
        </TableRow>
    );
};

export default InvoiceConfigTable;
